// Utilidades para nodo document_pdf

// Regex backend: @([A-Za-z_][A-Za-z0-9_]*)
const TOKEN_REGEX = /@([A-Za-z_][A-Za-z0-9_]*)/g;

/**
 * Extrae tokens @var desde uno o más strings, únicos y en orden de aparición.
 * @param {...string} sources
 * @returns {string[]} Array de tokens con @ (ej: ['@nombre','@email'])
 */
export function extractAtTokens(...sources) {
  const seen = new Set();
  const result = [];

  for (const source of sources) {
    if (!source || typeof source !== 'string') continue;

    for (const match of source.matchAll(TOKEN_REGEX)) {
      const name = match[1];
      const token = `@${name}`;
      if (!seen.has(token)) {
        seen.add(token);
        result.push(token);
      }
    }
  }

  return result;
}

/**
 * Normaliza Params a la forma esperada: [{name,value}]
 * Acepta undefined/null, objeto, string JSON, etc.
 * @param {any} params
 * @returns {{name:string,value:string}[]}
 */
export function normalizeDocumentPdfParams(params) {
  if (!params) return [];

  let parsed = params;
  if (typeof params === 'string') {
    try {
      parsed = JSON.parse(params);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(parsed)) return [];

  return parsed
    .filter((p) => p && typeof p === 'object')
    .map((p) => ({
      name: typeof p.name === 'string' ? p.name : '',
      value: typeof p.value === 'string' ? p.value : '',
    }))
    .filter((p) => p.name.length > 0);
}

/**
 * Asegura que exista un registro por token y preserva valores existentes.
 * Devuelve array con orden igual a tokens.
 * @param {string[]} tokens Con @
 * @param {{name:string,value:string}[]} params
 */
export function mergeParamsForTokens(tokens, params) {
  const byName = new Map();
  for (const p of normalizeDocumentPdfParams(params)) {
    byName.set(p.name, p.value || '');
  }

  return tokens.map((t) => {
    const name = t.startsWith('@') ? t.slice(1) : t;
    return { name, value: byName.get(name) || '' };
  });
}

/**
 * Limpia input del usuario tipo "{{var}}" a "var".
 * @param {string} s
 */
export function stripMustache(s) {
  if (!s) return '';
  const trimmed = String(s).trim();
  const m = trimmed.match(/^\{\{\s*([^}]+?)\s*}}$/);
  return m ? m[1].trim() : trimmed;
}

/**
 * Formatea nombre de variable del flow a "{{var}}" para mostrar.
 * @param {string} s nombre sin llaves
 */
export function toMustache(s) {
  const inner = stripMustache(s);
  return inner ? `{{${inner}}}` : '';
}
